/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-22 14:31:25
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-07 16:19:12
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/slice/index.ts
 */
import { createSelector, createSlice } from '@reduxjs/toolkit';
import arrayMove from 'array-move';
import { get } from 'lodash';
import {
  addDraggableCollapse,
  deleteDraggableCollapse,
} from 'src/constrains/DraggableModules/reduxFunctions';
import {
  //generateResponsiveImage,
  generateResponsiveImageLayer,
} from 'src/constrains/DraggableModules/tools';
import { onCollapseOpen as _onCollapseOpen } from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import { EnumReducers } from 'src/store/constants';
import { ActionType } from 'src/types/common/common';
import { ENewTabLayerType } from 'src/types/common/module';
import { convertDataFromImage } from './tools';

const target = (state) => {
  //console.log('state', state);
  return state[EnumReducers.responsiveLayerEditor];
};

const defaultData = {
  selected: false,
  originalData: null,
  image: null,
  type: null,
  additionalData: null,
  // selected: true,
  // originalData: {
  //   imageId: '123',
  //   contentListId: '123',
  //   //type: ENewTabLayerType.Image,
  // },
  // image: convertDataFromImage(generateResponsiveImage()),
  // type: ENewTabLayerType.Image,
  // additionalData: null,
};

const responsiveContentLayerEditor = createSlice({
  //操作image=poster
  name: 'responsiveLayerEditor',
  initialState: defaultData,
  reducers: {
    onImageCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state.image, idArr);
    },
    onImageErrorChange(state, action) {
      const { id, status } = action.payload;
      state.image.collapseErrorMsgDisplay[id].hasError = status;
    },
    onClearData(state) {
      state.selected = false;
      state.originalData = null;
      state.image = null;
      state.type = null;
      state.additionalData = null;
    },
    onLoadData(state, action) {
      state.selected = true;
      const { type } = action.payload;
      state.type = type;
      if (type === ENewTabLayerType.Image || type === ENewTabLayerType.Poster) {
        const { contentListId, imageId, data, additionalData } = action.payload;
        state.image = convertDataFromImage(data);
        state.originalData = {
          imageId,
          contentListId,
          //type,
        };
        state.additionalData = additionalData;
      }
      //console.log(action.payload);
      //state.data = action.payload;
    },
    onImageCarouselSettingChange(state, action) {
      state.image = {
        ...(state.image || {}),
        ...action.payload,
      };
    },
    onImageLayerChange(state, action) {
      const { type } = action.payload;
      if (type === ActionType.delete) {
        const { index, draggableId } = action.payload;
        state.image.layers.splice(index, 1);
        deleteDraggableCollapse(state.image, draggableId);
      }
      if (type === ActionType.add) {
        //const amount = state.image.layers.length;
        const newLayer = generateResponsiveImageLayer();
        //console.log('newLayer', newLayer);
        const { draggableId } = newLayer;
        state.image.layers.push(newLayer);
        addDraggableCollapse(state.image, draggableId);
      }
      if (type === ActionType.reorder) {
        const { from, to } = action.payload;
        state.image.layers = arrayMove(state.image.layers, from, to);
      }
      if (type === ActionType.modify) {
        const { index, target } = action.payload;
        state.image.layers[index] = {
          ...state.image.layers[index],
          ...target,
        };
      }
    },
    // onStyleChange(state, action) {
    //   const { uuid, style } = action.payload;
    //   state.siteStyle = style;
    //   state.nativeChannelType[uuid] = { style ,error:false};
    // },
  },
  extraReducers: (builder) => {
    // builder.addCase(fetchSalesChannel.fulfilled, (state, action) => {
    //   state.loading = false;
    //   assData(state, action.payload || {});
    // });
    // builder.addCase(fetchSalesChannel.pending, (state, action) => {
    //   state.loading = true;
    // });
    // builder.addCase(fetchSalesChannel.rejected, (state, action) => {
    //   state.loading = false;
    // });
  },
});
export {
  getSelected,
  getImage,
  getAdditionalData,
  getImageCarouselSetting,
  getImageCollapseOpenStatus,
  getImageCollapseValidationMsgDisplay,
  getImageCarouselLayer,
  getImageBackData,
};
export const {
  onLoadData,
  onClearData,
  onImageCarouselSettingChange,
  onImageCollapseOpen,
  onImageErrorChange,
  onImageLayerChange,
} = responsiveContentLayerEditor.actions;
const getSelected = () => {
  return createSelector(
    (state: any) => {
      const selected = get(target(state), 'selected');
      const type = get(target(state), 'type');
      const name = get(target(state), 'image.name');
      return { type, selected, name };
    },
    (data) => {
      return data;
    },
  );
};

const getImageBackData = () => {
  return createSelector(
    (state: any) => {
      const data = get(target(state), 'image');
      const { collapseErrorMsgDisplay, ...rest } = data;
      const hasError = !!Object.values(collapseErrorMsgDisplay).find((i) =>
        get(i, 'hasError'),
      );

      const originalData = get(target(state), 'originalData');
      const additionalData = get(target(state), 'additionalData');
      return { from: originalData, data: rest, hasError, additionalData };
    },
    (image) => {
      return image;
    },
  );
};

const getImage = () => {
  return createSelector(
    (state: any) => {
      const data = get(target(state), 'image');
      return data;
    },
    (image) => {
      return image;
    },
  );
};

const getImageCarouselSetting = () => {
  return createSelector(
    (state: any) => {
      //onsole.log('state', state);
      const name = get(target(state), 'image.name');
      const image = get(target(state), 'image.image');
      const imageLink = get(target(state), 'image.imageLink');
      const background = get(target(state), 'image.background');
      const autoplayEnabled = get(target(state), 'image.autoplayEnabled');
      const mute = get(target(state), 'image.mute');

      return { name, image, imageLink, background, autoplayEnabled, mute };
    },
    (image) => {
      return image;
    },
  );
};

const getImageCarouselLayer = () => {
  return createSelector(
    (state: any) => {
      const layers = get(target(state), 'image.layers');

      return layers;
    },
    (layers) => {
      return layers;
    },
  );
};

const getAdditionalData = () => {
  return createSelector(
    (state: any) => {
      const data = get(target(state), 'additionalData');
      return data;
    },
    (image) => {
      return image;
    },
  );
};

const getImageCollapseOpenStatus = (id) => {
  return createSelector(
    (state: any) => {
      return target(state).image.collapseOpen[id];
    },
    (open) => {
      return open;
    },
  );
};

const getImageCollapseValidationMsgDisplay = (id) => {
  return createSelector(
    (state: any) => {
      return target(state).image.collapseErrorMsgDisplay[id];
    },
    (status) => {
      return status;
    },
  );
};

export default responsiveContentLayerEditor.reducer;
